import styled from 'styled-components';
import { colors, Button, typography } from '@insurancemenu/imenu-components-lib';

export const ClassSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ClassButtonStyled = styled(Button)`
  padding-left: 0;

  /* Align vertically with the other components */
  margin-top: -0.5rem;
`;

export const SelectedClassStyled = styled.div`
  display: flex;
  margin-top: 0.5rem;
`;

export const ClassIconStyled = styled.span`
  margin-right: 1rem;
`;

export const ClassNameStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.neutral[900]};
`;

export const ClassOptionLabelStyled = styled.span`
  width: fit-content;
  overflow-wrap: anywhere;
`;
